export enum ButtonStatus {
  default = 'default',
  clicked = 'clicked',
  hidden = 'hidden',
}

export type Props = {
  onEmailDiscover?: VoidFunction;
};
